import { type V3 } from "@project-rouge/rg-core";

export function GetPolygonEdges(polygon: V3[]): [V3, V3][] {
  const lines: [V3, V3][] = [];
  for (let i = 0; i < polygon.length - 1; i++) lines.push([polygon[i], polygon[i + 1]]);
  return lines;
}
